import {
  EventActions,
  EventNames,
  TrackingEvent,
  TrackingEventTypes,
} from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Datadog } from '@cinch-nx/landing-ui-shared'
const { Actions, Context } = Datadog

type TrackEventLabel = 'make' | 'model' | 'monthly price' | 'total price'

const getValueOrAny = (value: string | undefined) => (value ? value : 'any')

type OnChangeProps = {
  trackEventLabel: TrackEventLabel
  value?: string
  datadogActionName: Datadog.Actions
}

export function createTrackers(trackEvent: (event: TrackingEvent) => void) {
  return {
    onChange({ trackEventLabel, value, datadogActionName }: OnChangeProps) {
      trackEvent({
        eventName: `Homepage ${trackEventLabel} dropdown`,
        type: TrackingEventTypes.ADOBE,
        data: {
          event: {
            name: EventNames.click,
            category: 'hero',
            action: EventActions.select,
            label: trackEventLabel,
            value: value?.toLowerCase(),
            type: 'used',
          },
        },
      })

      datadogRum.addAction(datadogActionName, {
        service: Context.HERO_SEARCH,
        squad: Context.SQUAD,
        page: window.location.pathname,
        value: value?.toLowerCase(),
      })
    },

    onSubmit(selectedMake?: string, selectedModel?: string, price?: string) {
      const searchTrackEventValue = `search cars make: ${getValueOrAny(
        selectedMake,
      )}, model: ${getValueOrAny(selectedModel)}, ${getValueOrAny(price)}`

      trackEvent({
        eventName: `Click on 'Search x used cars' CTA button`,
        type: TrackingEventTypes.ADOBE,
        data: {
          event: {
            name: EventNames.click,
            category: 'hero',
            action: 'submit',
            label: 'search cars',
            value: searchTrackEventValue,
            type: 'used',
          },
        },
      })

      datadogRum.addAction(Actions.CLICK_SEARCH_CTA, {
        service: Context.HERO_SEARCH,
        squad: Context.SQUAD,
        page: window.location.pathname,
        value: searchTrackEventValue,
      })
    },
  }
}
